import type { ChainId } from '@morpho-org/blue-sdk'
import type { Address } from 'viem'

import { orpc } from '@/lib/orpc/client'

import type { AllocationTransactionsOutput } from './allocationTransactions.contract'

export interface AllocationTransactionsQueryInput {
  chainId: ChainId
  address: Address
  limit: number
}

/** What a vault the bridge does not know shows: no history. */
export const NO_TRANSACTIONS: AllocationTransactionsOutput = {
  items: [],
  partial: false,
  nextCursor: null
}

/** The key the server seeds and `useAllocationTransactionsData` reads. */
export const allocationTransactionsQueryKey = (input: AllocationTransactionsQueryInput) =>
  orpc.vaultV2.allocationTransactions.key({ input, type: 'infinite' })

/** The procedure's `nextCursor` page, in the `pageInfo` shape `useCursorPagination` walks. */
export function toCursorPage(page: AllocationTransactionsOutput) {
  return {
    ...page,
    pageInfo: { hasNextPage: page.nextCursor !== null, endCursor: page.nextCursor }
  }
}

export type AllocationTransactionsCursorPage = ReturnType<typeof toCursorPage>
